export default "__VITE_ASSET__4ae8ac22__"